<template>
  <div>
    <ClientSearch ref="mdlClientSearch" @submit="handleClient_Submit"/>

    <kst-warning class="mb-4" :items="detailsWarning"/>

    <kst-input load-on-focus field="IsAutoNumber" :data="userData" :catalog="Catalog">
      <template #right>
        <kst-input addons expanded field-only
          v-show="!userData.IsAutoNumber"
          field="DraftNumber" :data="userData" :catalog="Catalog"
          :customValidations="numberValidations"
        />
      </template>
    </kst-input>
    <kst-input field="Date" :data="userData" :catalog="Catalog"/>

    <kst-output control-off status-off
      field="ClientID" :data="userData" :catalog="Catalog"
    >
      <template #left>
        <kst-output addons floating-label
          field="ClientAlias" :data="userData" :catalog="Catalog"
        />
      </template>
      <template #default>
        <kst-input addons expanded floating-label
          field="ClientName"
          :disabled="userData.ClientID !== null"
          :data="userData"
          :catalog="Catalog"
        />
      </template>
      <template #right>
        <div class="control">
          <template v-if="userData.ClientID === null">
            <kst-tooltip search-mode hover-only :content="Catalog.ClientID.Label">
              <kst-button search-mode @click="handleSearch_Client"/>
            </kst-tooltip>
          </template>
          <template v-else>
            <kst-tooltip clear-mode hover-only :content="Catalog.ClientID.Label">
              <kst-button clear-mode @click="handleClear_Client"/>
            </kst-tooltip>
          </template>
        </div>
      </template>
    </kst-output>

    <kst-input field="ClientAddress" :data="userData" :catalog="Catalog"/>
    <kst-input field="WarehouseID" :data="userData" :catalog="Catalog"
      :disabled="userItems.length > 0" :options="warehouseOptions"
    />
    <kst-input field="PONumber" :data="userData" :catalog="Catalog"/>
  </div>
</template>

<script>
import Catalog from "../SalesCatalog.js";
import Info from "../SalesInfo.js";
import Model from "../SalesModel.js";

import ClientSearch from "@/components/Client/Search/ClientSearch";

export default {
  components: {
    ClientSearch
  },
  props: {
    userData: Object,
    userItems: Array,
    warehouseOptions: Object
  },
  data: () => ({
    Catalog: Catalog,
    Model: Model
  }),
  computed: {
    detailsWarning() {
      return [Info.Message.New_Warehouse];
    },
    numberValidations() {
      return Model.validationNumber(this.userData);
    }
  },
  methods: {
    handleSearch_Client() {
      this.$refs.mdlClientSearch.show();
    },
    handleClear_Client() {
      Model.clearDetailsByClient(this.userData);
    },
    handleClient_Submit(row) {
      Model.setDetailsByClient(this.userData, row);
    }
  }
}
</script>